









import { Component, Vue, Ref } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { IActionType } from '@/system/store'
import { JOB_LIST_NAME } from '@/features/job/job.router'
import { PROJECT_LIST_NAME } from '@/features/projectList/projectList.router'
import { MATCH_FIELDS_NAME } from '@/features/matchFields/matchFields.router'
import { navBarLocalisationKeys } from '@/features/navBar/navBar.localisation'
import HomeConfirmationDialog from '@/features/navBar/components/HomeConfirmationDialog.vue'
@Component({
  components: {
    HomeConfirmationDialog
  }
})
export default class Home extends Vue {
  private translations = navBarLocalisationKeys

  @Ref()
  readonly modal!: HomeConfirmationDialog

  private handleHome (): void {
    const { name } = this.$router.currentRoute

    if ([MATCH_FIELDS_NAME, PROJECT_LIST_NAME].includes(name)) return this.modal.openDialog()
    this.$router.push({ name: JOB_LIST_NAME })
  }
}
